module.exports = {"shipment":{"supplier":"生産者","arrival_date":"荷受日","arrival_time":"荷受時刻","port":"荷受場所","journal_date_auto":"計上日自動指定","journal_date":"計上日","supseq":"生産者別通番","num":"荷受番号"},"timetable":{"supplier":"生産者","shipment":"荷受No","toggle":"絞り込み"},"pl_menu":"荷受","page_title":{"pl_fetch":"持込インポート"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/lang/modules/jfd/ja.json
// module id = lWRo
// module chunks = 120